// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top{flex-direction:row;justify-content:space-between}.contextShow,.top{display:flex;margin-top:15px;width:80%}.contextShow{flex-direction:column;line-height:45px;font-size:15px;text-align:left}.title{font-weight:700;@include change_size($font_size_normal)}.text{color:#5af}.context{display:flex;flex-direction:column;color:#737373;font-size:15px}.context,.text1{margin-left:15px;line-height:35px}", ""]);
// Exports
module.exports = exports;
